<div class="url-address">
  <span>{{ postbackUrlForEdit }}</span>
</div>

<div *ngIf="postbackTestData?.postback_url" class="postback-url-parameters">
  <app-postback-url-parameters [urlAddress]="postbackTestData?.postback_url ?? ''" [usedParameters]="usedParameters" [isUrlValid]="false">
  </app-postback-url-parameters>
</div>
<div class="postback-url-parameters-inputs">
  <!-- <app-select-container
    [data]="selectData.data"
    [title]="selectData.title"
    [submitted]="false"
    [shouldTranslate]="true"
    (emitValue)="getSelectedValue($event)"
    [idOfDefaultValue]="idOfDefaultValue">
    </app-select-container> -->

  <ng-container *ngIf="!usedParameters.includes('currency')">
    <app-text-input
      class="postback-input"
      [inputName]="'currency'"
      [fieldInfo]="{ system_name: 'currency' }"
      [disabled]="true"
      [configurationData]="[{ system_name: 'currency', config_values: currency }]"
      [doNotTranslateLabel]="true"
      [validators]="['required', 'max-length']"
      [maxLength]="160"
      [componentLoaded]="true">
    </app-text-input>
  </ng-container>
  <ng-container *ngFor="let parameter of usedParameters">
    <ng-container *ngIf="parameter !== 'status' else statusInput">
      <app-text-input
        class="postback-input"
        (emitValue)="setInputValue($event)"
        [inputName]="parameter"
        [fieldInfo]="{ system_name: parameter }"
        [configurationData]="[{ system_name: parameter, config_values: paramsList[parameter] }]"
        [doNotTranslateLabel]="true"
        [validators]="['required', 'max-length']"
        [maxLength]="160"
        [componentLoaded]="true">
      </app-text-input>
    </ng-container>
    <ng-template #statusInput>
      <app-select-container
        class="postback-input"
        [data]="selectData.data"
        [title]="selectData.title"
        [submitted]="false"
        [shouldTranslate]="true"
        (emitValue)="setSelectedValue($event)"
        [idOfDefaultValue]="idOfDefaultValue">
      </app-select-container>
    </ng-template>
  </ng-container>
</div>

<div class="btn-container" style="margin-right: 20px">
  <app-primary-button (emitAction)="setDefaultValues()" [background]="'green'" [buttonText]="'fill_with_defaults'" [iconSize]="18" [icon]="'code'">
  </app-primary-button>
</div>
<div class="btn-container">
  <app-primary-button (emitAction)="sendPostbackTest()" [background]="'orange'" [buttonText]="'send_test'" [iconSize]="18" [icon]="'link'">
  </app-primary-button>
</div>
